document.addEventListener('DOMContentLoaded', () => {
    initCartProgressBar();
    observeCartChanges();
});

// Watch for cart changes via events
['cart:updated', 'cart:item-added', 'cart:item-removed', 'change'].forEach(event => {
    document.addEventListener(event, () => {
        setTimeout(initCartProgressBar, 500);
    });
});

function observeCartChanges() {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length) {
                mutation.addedNodes.forEach(node => {
                    if (node.querySelector && (node.querySelector('.cart-progress-bar-container') || node.classList && node.classList.contains('cart-progress-bar-container'))) {
                        initCartProgressBar();
                    }
                });
            }
        });
    });
    observer.observe(document.body, { childList: true, subtree: true });
}

function initCartProgressBar() {
    const bars = document.querySelectorAll('.cart-progress-bar-container');
    bars.forEach(progressBar => {
        const count = parseInt(progressBar.dataset.count || '0');
        const goal = parseInt(progressBar.dataset.goal || '3');
        const fill = progressBar.querySelector('.cart-progress-bar__fill');

        if (fill) {
            let percent = (count / goal) * 100;
            if (percent > 100) percent = 100;

            requestAnimationFrame(() => {
                fill.style.width = `${percent}%`;
            });
        }

        // Mark steps and milestones as reached based on count
        const steps = progressBar.querySelectorAll('.cart-progress-bar__step');
        steps.forEach(step => {
            const left = parseFloat(step.style.left);
            // Calculate which step number this represents based on its position
            const stepGoal = Math.round((left / 100) * goal);
            if (count >= stepGoal) {
                if (!step.classList.contains('is-reached')) {
                    step.classList.add('is-reached', 'pop-animation');
                    setTimeout(() => step.classList.remove('pop-animation'), 600);
                }
            } else {
                step.classList.remove('is-reached', 'pop-animation');
            }
        });

        // Mark milestones as reached
        const milestones = progressBar.querySelectorAll('.cart-progress-bar__milestone');
        milestones.forEach(m => {
            if (m.classList.contains('milestone-0')) {
                // Start milestone is always reached
                m.classList.add('is-reached');
            } else if (m.classList.contains('milestone-end')) {
                // End milestone — reached when count >= goal
                if (count >= goal) {
                    if (!m.classList.contains('is-reached')) {
                        m.classList.add('is-reached', 'pop-animation');
                        setTimeout(() => m.classList.remove('pop-animation'), 600);
                    }
                } else {
                    m.classList.remove('is-reached', 'pop-animation');
                }
            }
        });
    });
}
